import PreferenceMappingModel from "../../../../Global/Models/PreferenceMapping/PreferenceMappingModel";
import MiniGameImages from "../MiniGameImages";
import PersonalityQuizPersonaPointsModel from "./PersonalityQuizPersonaPointsModel";

export default class PersonalityQuizOptionModel {
  public optionId: number = null;
  public option: string = null;
  public images: MiniGameImages | null = null;
  public personaPoints: PersonalityQuizPersonaPointsModel[] = [];
  public preferencesMapping: PreferenceMappingModel[] = [];
}
